import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import WithTooltip from 'components/WithTooltip'

export default class Bar extends React.Component {
  static propTypes = {
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    color: PropTypes.string,
    opacity: PropTypes.number,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    tooltip: PropTypes.string
  }

  render() {
    const {color, tooltip, ...restProps} = this.props
    const className = classnames('bar', {
      [`is-${color}`]: color,
      'has-hover': !!this.props.onMouseEnter
    })

    if (tooltip) {
      return (
        <WithTooltip title={tooltip} style='blue'>
          <rect className={className} {...restProps} />
        </WithTooltip>
      )
    } else {
      return <rect className={className} {...restProps} />
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/Chart/Bar.js